<script setup lang="ts">
// import {} from '@gql'

// const props = defineProps<{
// }>()
</script>

<template>
  <div :class="$style.b"><slot /></div>
</template>

<style module>
.b {
  composes: global(_relative);
  composes: global(_scroll);
  composes: global(_h100p);
  composes: global(_bg0);
}
.b::after,
.b::before {
  position: sticky;
  left: 0;
  z-index: 2;
  display: block;
  width: 100%;
  height: 10px;
  pointer-events: none;
  content: "";
}
.b::before {
  top: 0;
  background: linear-gradient(0deg, #fff0, #fff);
}
.b::after {
  bottom: 0;
  background: linear-gradient(0deg, #fff, #fff0);
}
</style>
